import React from 'react';
import { motion } from 'framer-motion';
interface ProgressRingProps {
  value: number;
  size?: number;
  stroke?: number;
  children?: React.ReactNode;
  tone?: 'pulse' | 'light';
}
export function ProgressRing({
  value,
  size = 120,
  stroke = 8,
  children,
  tone = 'pulse'
}: ProgressRingProps) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return <div className="relative grid place-items-center" style={{
    width: size,
    height: size
  }} role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100} data-id="element-690" data-mp="itmwvmp6umgf">
      <svg width={size} height={size} className="-rotate-90" aria-hidden data-id="element-691" data-mp="erryor2k0p6v">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} className={tone === 'light' ? 'stroke-white/15' : 'stroke-ink-200'} data-id="element-692" data-mp="sqhu829q6gt4" />
        <motion.circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} strokeLinecap="round" className={tone === 'light' ? 'stroke-white' : 'stroke-pulse-600'} strokeDasharray={c} initial={{
        strokeDashoffset: c
      }} animate={{
        strokeDashoffset: c - c * value / 100
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1],
        delay: 0.15
      }} data-id="element-693" data-mp="2uj62iq187ufr" />
      </svg>
      <div className="absolute inset-0 grid place-items-center" data-id="element-694" data-mp="2a7942w96ftu">{children}</div>
    </div>;
}